
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91sectionUrl_93PoiY7nu3BrMeta } from "/vercel/path0/pages/[sectionUrl].vue?macro=true";
import { default as _91articleId_93866PvkcugfMeta } from "/vercel/path0/pages/article-detail/[articleId].vue?macro=true";
import { default as _91articleUrl_93O0SN2XKn4KMeta } from "/vercel/path0/pages/articles/[articleUrl].vue?macro=true";
import { default as _91authorUrl_9315Japjop0VMeta } from "/vercel/path0/pages/authors/[authorUrl].vue?macro=true";
import { default as indexFpUUtAJFciMeta } from "/vercel/path0/pages/debug/index.vue?macro=true";
import { default as _91articleUrl_93uir227YTTCMeta } from "/vercel/path0/pages/galleries/[articleUrl].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as indexoOBDY93e9EMeta } from "/vercel/path0/pages/login/index.vue?macro=true";
import { default as refreshm5pzZYuN71Meta } from "/vercel/path0/pages/login/refresh.vue?macro=true";
import { default as indexOU1SMEquWRMeta } from "/vercel/path0/pages/newsletter/confirmation/index.vue?macro=true";
import { default as indexkrT2YGg0DcMeta } from "/vercel/path0/pages/newsletter/index.vue?macro=true";
import { default as _91authorId_937uWziyybc0Meta } from "/vercel/path0/pages/newsroom/[authorId].vue?macro=true";
import { default as indexXoRKgcabZZMeta } from "/vercel/path0/pages/newsroom/index.vue?macro=true";
import { default as indexSsrwCXeuTQMeta } from "/vercel/path0/pages/profile/index.vue?macro=true";
import { default as indexDqV3Lxa5AvMeta } from "/vercel/path0/pages/search/index.vue?macro=true";
export default [
  {
    name: "sectionUrl___cs",
    path: "/:sectionUrl()",
    meta: _91sectionUrl_93PoiY7nu3BrMeta || {},
    component: () => import("/vercel/path0/pages/[sectionUrl].vue")
  },
  {
    name: "article-detail-articleId___cs",
    path: "/article-detail/:articleId()",
    meta: _91articleId_93866PvkcugfMeta || {},
    component: () => import("/vercel/path0/pages/article-detail/[articleId].vue")
  },
  {
    name: "articles-articleUrl___cs",
    path: "/clanek/:articleUrl()",
    meta: _91articleUrl_93O0SN2XKn4KMeta || {},
    component: () => import("/vercel/path0/pages/articles/[articleUrl].vue")
  },
  {
    name: "authors-authorUrl___cs",
    path: "/autor/:authorUrl()",
    meta: _91authorUrl_9315Japjop0VMeta || {},
    component: () => import("/vercel/path0/pages/authors/[authorUrl].vue")
  },
  {
    name: "debug___cs",
    path: "/debug",
    component: () => import("/vercel/path0/pages/debug/index.vue")
  },
  {
    name: "galleries-articleUrl___cs",
    path: "/galerie/:articleUrl()",
    meta: _91articleUrl_93uir227YTTCMeta || {},
    component: () => import("/vercel/path0/pages/galleries/[articleUrl].vue")
  },
  {
    name: "homepage___cs",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/login",
    component: () => import("/vercel/path0/pages/login/index.vue")
  },
  {
    name: "login-refresh___cs",
    path: "/login/refresh",
    component: () => import("/vercel/path0/pages/login/refresh.vue")
  },
  {
    name: "newsletter-confirmation___cs",
    path: "/newsletter/confirmation",
    meta: indexOU1SMEquWRMeta || {},
    component: () => import("/vercel/path0/pages/newsletter/confirmation/index.vue")
  },
  {
    name: "newsletter___cs",
    path: "/newsletter",
    meta: indexkrT2YGg0DcMeta || {},
    component: () => import("/vercel/path0/pages/newsletter/index.vue")
  },
  {
    name: "newsroom-authorId___cs",
    path: "/redakce/:authorId()",
    meta: _91authorId_937uWziyybc0Meta || {},
    component: () => import("/vercel/path0/pages/newsroom/[authorId].vue")
  },
  {
    name: "newsroom___cs",
    path: "/redakce",
    meta: indexXoRKgcabZZMeta || {},
    component: () => import("/vercel/path0/pages/newsroom/index.vue")
  },
  {
    name: "profile___cs",
    path: "/profil",
    meta: indexSsrwCXeuTQMeta || {},
    component: () => import("/vercel/path0/pages/profile/index.vue")
  },
  {
    name: "search___cs",
    path: "/hledej",
    meta: indexDqV3Lxa5AvMeta || {},
    component: () => import("/vercel/path0/pages/search/index.vue")
  }
]